import type { ActiveViewData, VIEW_TYPE } from '@/common/helpers/view-types';
import { prefStorage } from '@samknows/utils';
import { isVolunteer } from '@/common/services/account/user';
import { saveIsUnitTriggerTestingEnabled } from '@/common/services/account/userPreferences';

/**
 * Main path to redirect the user to upon login
 * Depends on what they have access to
 *
 * @returns {string} Path to redirect to
 */
export function getDefaultPath(): string {
  if (isVolunteer()) {
    return '/volunteers/profile';
  }

  return '/volunteers/dashboard';
}

/**
 * Switch the currently loaded globally loaded unit to a new unit
 * Used for users who have multiple whiteboxes
 */
export function goToView(type: VIEW_TYPE, data: ActiveViewData): void {
  const promise = saveIsUnitTriggerTestingEnabled(data.unitId);

  prefStorage.set('active-view', { type, data });

  // If setting instant testable, wait until it's stored before continuing
  promise.then(() => {
    window.location.reload();
  });
}

export function goToThousandEyesLogin(): void {
  window.location.href = `/login`;
}
